import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="contact" className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <h3 className="footer-title">Get In Touch</h3>
          <div className="footer-links">
            <a href="mailto:ceaustin117@gmail.com" className="footer-link" aria-label="Email">
              ceaustin117@gmail.com
            </a>
            <a href="https://www.linkedin.com/in/christopher-austin/" target="_blank" rel="noopener noreferrer" className="footer-link" aria-label="LinkedIn">
              LinkedIn
            </a>
            <a href="https://github.com/Ceaustin117" target="_blank" rel="noopener noreferrer" className="footer-link" aria-label="GitHub">
              GitHub
            </a>
          </div>
        </div>
        <p className="footer-copyright">&copy; {currentYear} Chris Austin. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer; 